<template>
  <svg
    class="custom-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M6.37688 16.6932C7.68225 16.6932 8.98673 16.19 9.97085 15.2072L11.2794 13.9011C11.6866 13.4944 11.696 12.8085 11.2764 12.3678C10.8684 11.9637 10.183 11.9554 9.74257 12.374L8.43733 13.677C7.29358 14.8193 5.46031 14.8193 4.31638 13.677C3.17236 12.5343 3.17252 10.7024 4.31646 9.55954L5.62656 8.25179C6.03368 7.84507 6.04308 7.15928 5.62346 6.71857C5.21553 6.31446 4.53012 6.30621 4.08969 6.72486L2.7828 8.02941C0.817004 9.99292 0.814449 13.2173 2.78378 15.2079C3.76759 16.1902 5.07188 16.6932 6.37688 16.6932Z"
      fill="rgb(var(--v-theme-primary))"
    />
    <path
      d="M13.8181 11.2781L15.0276 10.0956C16.992 8.13201 16.9941 4.90874 15.0253 2.91858C13.0568 0.953312 9.82885 0.931417 7.83831 2.91951L6.67358 4.0819C6.26649 4.48862 6.2571 5.17439 6.67671 5.61508C7.08464 6.0192 7.77007 6.02744 8.21051 5.60878L9.37204 4.44958C9.9148 3.90753 10.6577 3.59281 11.4324 3.59281C12.2071 3.59281 12.9501 3.90758 13.4928 4.4497C14.6369 5.59234 14.6367 7.42431 13.4927 8.56713L12.2897 9.76784C11.8844 10.1726 11.8731 10.854 12.2868 11.2949C12.5101 11.4953 12.7814 11.6004 13.0685 11.6004C13.34 11.6004 13.6235 11.4901 13.8108 11.286L13.8181 11.2781Z"
      fill="rgb(var(--v-theme-primary))"
    />
    <path
      d="M8.1622 11.3426L8.16858 11.3356L11.3599 8.17281C11.7667 7.76605 11.7759 7.08053 11.3564 6.63995C10.9485 6.23584 10.2631 6.22758 9.8227 6.64619L6.64086 9.82419C6.23364 10.2309 6.22422 10.9168 6.64392 11.3575C6.85278 11.5647 7.11414 11.6569 7.41982 11.6569C7.69136 11.6569 7.97483 11.5467 8.1622 11.3426Z"
      fill="rgb(var(--v-theme-primary))"
    />
  </svg>
</template>
